// Migration-free onboarding tracking.
//
// We persist a small pointer in localStorage keyed by userId. It is set when
// onboarding starts (brand-new user), updated on every step, and cleared when the
// user finishes. "Finished" is anchored on hasActiveTier (the final plan step), so
// the pointer never resurfaces after completion. Existing users have no pointer and
// are therefore never pulled into onboarding.

const KEY_PREFIX = 'vibio_onboarding_'

const keyFor = (userId) => `${KEY_PREFIX}${userId}`

export function getOnboardingPointer(userId) {
    if (!userId) return null
    try {
        const raw = localStorage.getItem(keyFor(userId))
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}

export function setOnboardingPointer(userId, pointer) {
    if (!userId) return
    try {
        localStorage.setItem(keyFor(userId), JSON.stringify(pointer))
    } catch {
        // ignore storage failures (private mode, quota, etc.)
    }
}

export function clearOnboardingPointer(userId) {
    if (!userId) return
    try {
        localStorage.removeItem(keyFor(userId))
    } catch {
        // ignore
    }
}

export function startOnboarding(userId) {
    setOnboardingPointer(userId, { step: 0, userType: null, startedAt: Date.now() })
}

// True when the user has an in-progress onboarding to resume: a pointer exists and
// they have not yet completed the flow (hasActiveTier is set only at the plan step).
export function hasUnfinishedOnboarding(userData) {
    if (!userData || !userData.userId) return false
    if (userData.hasActiveTier) return false
    return getOnboardingPointer(userData.userId) != null
}
